var site = site || {};
var generic = generic || {};

(function ($) {
  Drupal.behaviors.guidedPickPromoV1 = {
    attach: function (context, settings) {
      var $formatter = $('.js-guided-pick-promo', context);
      var $liveChatSticky = $('.js-mobile-footer-sticky-navbar', context);
      var $offersParentConatiner = $('.js-offers', $formatter);
      var offers_sku = [];
      var $stickyElement = $('#sticky_bar_content');
      var $footerElement = $('#footer');
      var selectCopy = $formatter.attr('data-select');
      var selectedCopy = $formatter.attr('data-selected');
      var successaAddedCart = $formatter.attr('data-add-to-cart');
      var pleasePickCopy = $formatter.attr('data-please-pick');
      var pickComplete = $formatter.attr('data-pick-complete');
      var moreCopy = $formatter.attr('data-more');
      var columnCount = 3;
      var queryViewName = $formatter.attr('data-view-name');

      queryViewName = queryViewName !== '' ? queryViewName : 'guided_offers';
      // Setup Sticky Content for Guided Pick
      var $guidedStickyContainer = $('.js-sticky-guided-container');

      if ($('body').hasClass('device-mobile')) {
        $guidedStickyContainer.insertBefore($footerElement);
        columnCount = 2;
      } else {
        $stickyElement.html($guidedStickyContainer);
      }

      var $guidedRemaining = $('.js-guided-remaining', $stickyElement);
      // Get Offer Data using Offer Query and view(guided_offers) defined in the Offer Config File
      var params = {
        format_for: 'mustache',
        view: queryViewName
      };

      // To suppress livechat sticky nav for guided pick page
      $liveChatSticky.addClass('hidden');

      generic.jsonrpc.fetch({
        method: 'offers.query',
        params: [params],
        onSuccess: function (response) {
          var resultData = response.getValue();

          if (resultData !== null) {
            if (resultData.offers !== null) {
              // Set Offer Data
              setOfferData(resultData.offers);
            }
          }
        },
        onFailure: function () {
          // display error
          console.log('error fetching offer data');
        }
      });

      // Set Offer and Prodcut data
      function setOfferData(offerResultData) {
        _.forEach(offerResultData, function (offer, key) {
          offers_sku = [];
          try {
            var skus = offer.benefit_fields.ChoiceOfSkus.choices;
            var offerData = offer.fields;

            offerData.max_allowed = offer.benefit_fields.ChoiceOfSkus.max_allowed;
            offerData.max_to_show = offer.benefit_fields.ChoiceOfSkus.max_to_show;
            if (skus.length) {
              var choice = offer.benefit_fields.ChoiceOfSkus.choicesPcatData;

              if (!choice) {
                return true;
              }

              // Set SKU data
              jQuery.each(choice, function (index, data) {
                if (index >= offerData.max_to_show) {
                  return false;
                }
                var sku = data.sku;
                var $product = data.product;
                var skuData = {};

                skuData.SKU_BASE_ID = sku.SKU_ID.substr(3);
                skuData.SKU_ID = sku.SKU_ID;
                skuData.PROD_RGN_NAME = $product.PROD_RGN_NAME;
                skuData.PRODUCT_SIZE = $product.SHORT_DESC;
                skuData.IMAGE_3UP = sku.LARGE_IMAGE;
                skuData.PRODUCT_ID = $product.PRODUCT_ID;
                skuData.in_cart = data.in_cart[data.sku.SKU_BASE_ID];
                offers_sku.push(skuData);
              });

              if (offers_sku.length > 0) {
                // Rendered Products Data
                renderedProdcuts(offers_sku, offerData, key);
              }
            }
          } catch (e) {
            console.log('error fetching offer data');
          }
        });
      }

      // Rendered Products Data
      function renderedProdcuts(offers_sku, offerData, $offerKey) {
        // Update offer data
        var hasOfferContainer = $('.js-offer-container', $formatter).length > 0;
        var $offerContainer = hasOfferContainer
          ? $('.js-offer-container', $formatter).clone()
          : $('.js-offer-container-' + offerData.offer_code, $formatter).clone();
        $offerContainer
          .attr('max-allowed', offerData.max_allowed)
          .attr('offer-code', offerData.offer_code);
        $offerContainer.find('.js-offer-image').attr('src', offerData.image);
        $offerContainer
          .find('.js-guided-pick-products')
          .addClass('js-guided-pick-products-' + $offerKey);
        $offerContainer.addClass('guided_pick__container');
        $offerContainer.removeClass(
          'hidden js-offer-container js-offer-container-' + offerData.offer_code
        );
        $offersParentConatiner.append($offerContainer);
        updateStickyContent(0, offerData.max_allowed);

        // Rendered Products content
        _.forEach(offers_sku, function (skuData) {
          Drupal.cl.template.get({
            path: 'product_embed_inline',
            object: skuData,
            callback: function (html) {
              var result = _.unescape(html);

              if (result.length > 0) {
                var $offerConatiner = $(
                  '.js-guided-pick-products-' + $offerKey,
                  $offersParentConatiner
                );
                var $prodcutItem = $offerConatiner.find('.product-tout');
                var prodcutIndex = $prodcutItem.length;
                var rowIndex = prodcutIndex / columnCount;

                if (prodcutIndex % columnCount === 0) {
                  var row = $('<div/>');

                  row.addClass('pick-row pick-row' + rowIndex);
                  $offerConatiner.append(row);
                } else {
                  rowIndex = (prodcutIndex - (prodcutIndex % columnCount)) / columnCount;
                }
                var $rowItem = $offerConatiner.find('.pick-row' + rowIndex);

                if ($rowItem.length > 0) {
                  $rowItem.append(result);
                }
                $('.add-to-bag', $offersParentConatiner).text(selectCopy);
              }
            }
          });
        });
        setupSelectSample();
      }

      // Setup Select Sample Button Event
      function setupSelectSample() {
        var $sampleBtn = $('.product-tout', $formatter);

        $sampleBtn.off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var $productTout = $(this);
          var $offerData = $(this).parents('.js-offer');
          var $sampleItems = $offerData.find('.product-tout');
          var maxAlowed = $offerData.attr('max-allowed') ? $offerData.attr('max-allowed') : 1;
          var $offerBtn = $offerData.find('.js-offer-apply-button');
          var $selectElement = $productTout.find('.add-to-bag');
          var $guidedRemaining = $('.js-guided-remaining', $stickyElement);
          var $stickyOfferBtn = $guidedStickyContainer.find('.js-offer-apply-button');

          $offerBtn = $offerBtn.add($stickyOfferBtn);
          var $guidedRemainingContent = '';

          // De-select Sample button in Prodcut Tout
          if ($selectElement.hasClass('selected')) {
            // Deactive Procut Tout and Select Button
            $selectElement.removeClass('selected');
            $productTout.removeClass('active');
            $sampleItems.not('.active').removeClass('product-hide');
            $selectElement.text(selectCopy);

            // Disable Offer apply button when count reach 0
            if ($offerData.find('.selected').length === 0) {
              $offerBtn.removeClass('apply-offer-to-cart');
            }
            // Update Sticky Content
            updateStickyContent($offerData.find('.selected').length, maxAlowed);
          } else {
            // Select Sample button in Prodcut Tout
            if ($offerData.find('.selected').length < maxAlowed) {
              // Active Prodcut Tout and Select button
              $selectElement.addClass('selected');
              $selectElement.text(selectedCopy);
              $offerBtn.addClass('apply-offer-to-cart');
              $productTout.addClass('active');

              // Disable other Product Tout's when count reach MAX
              if ($offerData.find('.selected').length === parseInt(maxAlowed)) {
                $sampleItems.not('.active').addClass('product-hide');
              }

              // Update Sticky Content
              updateStickyContent($offerData.find('.selected').length, maxAlowed);
            }
          }
          if ($guidedRemainingContent !== '') {
            $guidedRemaining.html($guidedRemainingContent);
          }
        });
        setupAddToBag();
        if ($('body').hasClass('device-mobile')) {
          bottomStickyNav();
        }
      }

      // Setup Offer Apply Button Event
      function setupAddToBag() {
        var $stickyOfferBtn = $guidedStickyContainer.find('.js-offer-apply-button');
        var $applyOfferButton = $('.js-offer-apply-button', $formatter).not($stickyOfferBtn);

        $stickyOfferBtn.on('click', function () {
          $applyOfferButton.trigger('click');
        });
        $applyOfferButton.on('click', function () {
          if (!$(this).hasClass('apply-offer-to-cart')) {
            return;
          }
          // Get offer Data from Offer Container
          var $offerData = $(this).parents('.js-offer');
          var $selectElement = $offerData.find('.product-tout.active');
          var offerCode = $offerData.attr('offer-code');
          var maxAllowed = $offerData.attr('max-allowed');
          var $offerBtn = $offerData.find('.js-offer-apply-button');
          var $guidedLoading = $offerData.find('.js-guided-loading');
          var $stickyOfferBtn = $guidedStickyContainer.find('.js-offer-apply-button');
          var $stickyGuidedLoading = $guidedStickyContainer.find('.js-guided-loading');

          $offerBtn.hide();
          $stickyOfferBtn.hide();
          $guidedLoading.addClass('active');
          $stickyGuidedLoading.addClass('active');

          // Get Selected SKU's from Offer Container
          var $sampleItems = $offerData.find('.product-tout');
          var $selectElements = $offerData.find('.add-to-bag');
          var selectSkus = [];

          $selectElement.each(function (index, value) {
            var skuBaseId = $(value).find('.product').attr('data-skuid').substr(3);

            selectSkus.push(skuBaseId);
          });

          if (offerCode !== '' && selectSkus !== null) {
            // Set Offer Apply Params
            var params = {
              offer_code: offerCode,
              do_not_defer_messages: 1,
              benefits: {
                ChoiceOfSkus: {
                  choices: selectSkus
                }
              }
            };

            // Call Offer Apply Method
            generic.jsonrpc.fetch({
              method: 'offers.apply',
              params: [params],
              onBoth: function (r) {
                var messages = r.getMessages();
                var $content = '';

                // Set Result Content From RPC Response
                if (messages === null) {
                  // Set Success Content
                  $content = successaAddedCart;

                  // De-select Product Tout Elements
                  $selectElements.removeClass('selected').text(selectCopy);
                  $sampleItems.removeClass('active product-hide');
                  $offerBtn.removeClass('apply-offer-to-cart');
                  $stickyOfferBtn.removeClass('apply-offer-to-cart');
                  updateStickyContent(0, maxAllowed);

                  // Show cart Overlay After adding a Guided offer selection to cart
                  showCartOverlay();
                } else {
                  // Set Error Message
                  var $errorMsg = '';

                  $.each(messages, function (index, message) {
                    $errorMsg = $errorMsg + '  ' + message.text;
                  });
                  $content = $errorMsg;
                }

                // Show Result Content (Success or Error)
                generic.overlay.launch({
                  content: $content,
                  width: 335,
                  height: 310,
                  cssClass: 'guided_popup_overlay',
                  onOpen: function () {}
                });
                $offerBtn.show();
                $stickyOfferBtn.show();
                $guidedLoading.removeClass('active');
                $stickyGuidedLoading.removeClass('active');
              }
            });
          }
        });
      }

      // Update Sticky Content
      function updateStickyContent(count, maxAlowed) {
        var remainingCount = maxAlowed - count;
        var moreContent = remainingCount > 1 ? moreCopy : '';
        var $guidedRemainingContent = $('<span>').html(
          '<strong>' + pleasePickCopy + '</strong> ' + remainingCount + ' ' + moreContent
        );

        if (count === parseInt(maxAlowed)) {
          $guidedRemainingContent = $('<span>').html('<strong>' + pickComplete + '</strong>');
        }
        $guidedRemaining.html($guidedRemainingContent);
      }

      // Show Cart Overlay
      function showCartOverlay() {
        generic.jsonrpc.fetch({
          method: 'trans.get',
          params: [
            {
              trans_fields: ['TRANS_ID', 'totals'],
              payment_fields: [],
              order_fields: ['items', 'samples', 'offerCodes']
            }
          ],
          onSuccess: function (d) {
            var cartResponse = d.getValue();

            if (typeof cartResponse === 'undefined' || !cartResponse) {
              return;
            }
            var args = {
              trans: cartResponse,
              items: cartResponse.order.items
            };
            // This is a "hacky" way of forcing the cart confirm overlay to show after adding a Guided offer selection to cart
            var $gNavDropDown = $('.gnav-drop-down-v1');

            // Update the shopping bag items
            $gNavDropDown
              .find('.dd-icon')
              .find('.link')
              .find('[data-pg-prop="items_count"]')
              .text(cartResponse.items_count)
              .removeClass('hidden');
            // Manually trigger the cart confirm launch
            if (!site.client.isMobile) {
              site.cartConfirm.launch(args);
              // Show the cart confirm overlay
              $gNavDropDown
                .find('.dd-content')
                .find('.cart-confirm-wrapper')
                .closest('.gnav-drop-down-v1')
                .find('.dd-content')
                .toggleClass('active');
            }
          },
          onFailure: function (d) {
            // d.getError();
            console.log('Transaction JSON failed to load: ' + d.getError());
          }
        });
      }

      // Mobile Sticky Navigation
      function bottomStickyNav() {
        var $stickyBottomElement = $('.js-sticky-guided-container');
        var $footerElement = $('#footer');
        var elementPosition = $footerElement.offset();

        if (
          typeof elementPosition !== 'undefined' &&
          $(window).scrollTop() + $(window).height() + $stickyBottomElement.outerHeight(true) <
            elementPosition.top
        ) {
          $stickyBottomElement.addClass('sample_static');
        } else {
          $stickyBottomElement.removeClass('sample_static');
        }
      }
      $(window).on('scroll resize', _.debounce(bottomStickyNav, 50));
    }
  };
})(jQuery);
